'use client';

import type { StoryblokLinkResource, StoryblokLinkResultResource } from '@/components/customFields/types';
import SGFooter from '@/components/styleguideComponents/footer/footer';
import SGHeader from '@/components/styleguideComponents/header/header';
import classNames from 'classnames';
import { createContext, useMemo, useState } from 'react';

import SGList from '../list/list';
import classes from './guideLayout.module.scss';

export const GuideContext = createContext<StoryblokLinkResource[]>([]);

export default function GuideLayoutWrapper({
  storyList,
  headerTitle,
  children,
}: {
  storyList: StoryblokLinkResultResource;
  headerTitle: string;
  children: React.ReactNode;
}) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const list = useMemo(() => Object.values(storyList), [storyList]);

  return (
    <div className={classes.styleGuideContainer} data-testid="style-guide-main-layout">
      <SGHeader className={classes.styleGuideHeader} openMenu={mobileOpen} toggleMenu={handleDrawerToggle}>
        {headerTitle}
      </SGHeader>

      {mobileOpen ? (
        <button
          type="button"
          className={classes.menuBackdrop}
          aria-label="Menü schließen"
          onClick={handleDrawerClose}
        />
      ) : null}

      <aside
        className={classNames(classes.styleGuideMenu, {
          [classes.menuOpenMobile!]: mobileOpen,
        })}
        onTransitionEnd={handleDrawerTransitionEnd}
      >
        <div className={classes.menuPanel}>
          <SGList storyList={storyList} />
        </div>
      </aside>

      <div className={classes.styleGuidePage}>
        <GuideContext.Provider value={list}>
          <div className={classes.styleGuideContent}>{children}</div>
        </GuideContext.Provider>
        <SGFooter />
      </div>
    </div>
  );
}
